import React from 'react';

const Toggle = ({
  label,
  subLabel,
  defaultChecked = false,
  checked,
  onChange,
  variant = 'desktop'
}) => {
  const isControlled = typeof checked !== 'undefined';
  if (variant === 'mobile') {
    return (
      <div className="flex items-center justify-between pt-2 border-t border-notion-border">
        <span className="text-xs font-medium text-stone-600">{label}</span>
        <div className="relative inline-block w-9 align-middle select-none">
          <input
            type="checkbox"
            {...(isControlled ? { checked } : { defaultChecked })}
            onChange={(e) => onChange && onChange(e.target.checked)}
            className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-2 border-stone-300 appearance-none cursor-pointer checked:right-0"
          />
          <label className="toggle-label block overflow-hidden h-5 rounded-full bg-stone-300 cursor-pointer"></label>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between pt-2 border-t border-notion-border">
      <div className="flex flex-col">
        <span className="text-xs font-medium text-stone-600">{label}</span>
        {subLabel && <span className="text-[10px] text-stone-400">{subLabel}</span>}
      </div>
      <div className="relative inline-block w-10 align-middle select-none">
        <input
          type="checkbox"
          {...(isControlled ? { checked } : { defaultChecked })}
          onChange={(e) => onChange && onChange(e.target.checked)}
          className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer border-stone-300 checked:right-0"
        />
        <label className="toggle-label block overflow-hidden h-5 rounded-full bg-stone-200 cursor-pointer"></label>
      </div>
    </div>
  );
};

export default Toggle;
